(() => {
  const init = () => document.querySelectorAll('[data-j-storage]').forEach((root) => {
    if (root.dataset.jStorageReady === 'true') return;
    const controls = root.querySelector('.j-storage-compass__controls');
    const buttons = [...root.querySelectorAll('[data-storage-choice]')];
    const panels = [...root.querySelectorAll('[data-storage-panel]')];
    if (!controls || buttons.length !== 3 || panels.length !== 3) return;
    const choose = (button) => {
      buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      panels.forEach((panel) => { panel.hidden = panel.dataset.storagePanel !== button.dataset.storageChoice; });
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => choose(button));
      button.addEventListener('keydown', (event) => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = buttons.length - 1;
        else return;
        event.preventDefault();
        buttons[next].focus();
        choose(buttons[next]);
      });
    });
    choose(buttons[0]);
    controls.hidden = false;
    root.dataset.jStorageReady = 'true';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
